<life-di-nav></life-di-nav>
<lifedi-breadcrumb *ngIf="isEdit" lastPath="แก้ไขคอร์สเรียน"></lifedi-breadcrumb>
<lifedi-breadcrumb *ngIf="!isEdit" lastPath="สร้างคอร์สเรียน"></lifedi-breadcrumb>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>

<div class="container">
  <div *ngIf="isEdit && courseDetail?.COURSE_STATUS !== 1 && courseForm">
    <button mat-mini-fab color="warn" class="float-right btn-delete" (click)="deleteCourse(courseId)">
      <img src="../../../../assets/delete.png" style="width: 22px; margin-left: 4px; margin-top: -4px;">
    </button>
  </div>
  <div class="row justify-content-center">
    <h1 *ngIf="isEdit" class="lifedi-color mb-5">
      แก้ไขคอร์สเรียน
    </h1>
    <h1 *ngIf="!isEdit" class="lifedi-color mb-5">
      สร้างคอร์สเรียน
    </h1>
  </div>

  <div *ngIf="!isEdit">
    <form [formGroup]="courseForm">

      <div class="row d-flex justify-content-center">
        <div class="col-8">
          <div class="row d-flex justify-content-center">
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openReview" color="primary" class="form-control-plaintext" formControlName="openReview">
                เปิดการใช้งานรีวิว
              </mat-checkbox>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openChat" color="primary" class="form-control-plaintext" formControlName="openChat">
                เปิดการใช้งานห้องสนทนา
              </mat-checkbox>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openPrivateMessage" color="primary" class="form-control-plaintext"
                formControlName="openPrivateChat">
                เปิดการใช้งานข้อความส่วนตัว
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label for="courseNumber" class="col-4 col-sm-3 col-md-3 col-form-label">
              รหัสคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="text" class="form-control" id="courseNumber" formControlName="courseNumber"
                autocomplete="off" (focusout)="checkCourseNumber($event)">
              <small *ngIf="courseNumberSuccess" class="text-success">{{ courseNumberSuccess }}</small>
              <small *ngIf="courseNumberError" class="text-danger">{{ courseNumberError }}</small>
            </div>
          </div>
          <div class="form-group row">
            <label for="courseName" class="col-4 col-sm-3 col-md-3 col-form-label">
              ชื่อคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="text" class="form-control" id="courseName" formControlName="courseName" autocomplete="off">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseType" class="col-4 col-sm-3 col-md-3 col-form-label">
              ประเภทคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="display: inline;" formControlName="courseType">
                <option *ngFor="let c of courseType" [id]="c.ID" [value]="c.ID">{{ c.COURSE_TYPE_NAME }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacherId" class="col-4 col-sm-3 col-md-3 col-form-label">
              อาจารย์<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="display: inline;" formControlName="teacherId"
                (change)="selectTeacher($event)">
                <option *ngFor="let t of activeTeacher" [id]="t.TEACHER_ID" [value]="t.TEACHER_ID">
                  {{ t.USERNAME }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacherAssistant" class="col-4 col-sm-3 col-md-3 col-form-label">
              ผู้สอนร่วม <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <mat-form-field style="width: 100%;">
                <mat-select multiple id="teacherAssistant" formControlName="teacherAssistant"
                  [compareWith]="compareTeacherAssistant">
                  <mat-select-trigger>
                    <mat-chip-list>
                      <mat-chip *ngFor="let item of courseForm.value.teacherAssistant">
                        {{ item.USERNAME }}
                      </mat-chip>
                    </mat-chip-list>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of activeCoTeacherCutSelected" [value]="item">
                    {{ item.USERNAME }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-form-label">
              รูปปก<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <div class="custom-file">
                <input type="file" class="col-8 col-sm-9 col-md-9 custom-file-input" id="coursePic"
                  accept=".png, .jpg, .jpeg" (change)="onCoverSelected($event, courseForm)">
                <label *ngIf="!coursePic" class="custom-file-label" for="coursePic">Choose file</label>
                <label *ngIf="coursePic" class="custom-file-label" for="coursePic">{{ coursePic }}</label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-form-label">
              บัญชี<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="width: 100%;" formControlName="accountId">
                <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                  บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label class="col-4 col-sm-3 col-md-3 col-form-label">
              วิดีโอตัวอย่าง<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <div class="custom-file">
                <input #exampleVDO type="file" class="custom-file-input" id="exampleVDO"
                  accept="video/mp4, video/x-m4v, video/*" (change)="vdoChange($event, courseForm)">
                <label *ngIf="!exVdo" class="custom-file-label" for="exampleVDO">Choose file</label>
                <label *ngIf="exVdo" class="custom-file-label" for="exampleVDO">{{ exVdo }}</label>
                <small *ngIf="percentage">
                  <span *ngIf="percentage !== 100" class="text-danger">
                    อัปโหลดวิดีโอ {{ percentage | number : '1.0-1' }}%
                  </span>
                  <span *ngIf="percentage === 100" class="text-success">
                    อัปโหลดวิดีโอเรียบร้อย
                  </span>
                </small>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePrice" class="col-4 col-sm-3 col-md-3 col-form-label">
              ราคาปกติ<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="coursePrice" formControlName="coursePrice"
                autocomplete="off" min="0" step="100">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseSpacialPrice" class="col-4 col-sm-3 col-md-3 col-form-label">
              ราคาพิเศษ<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="courseSpacialPrice" formControlName="courseSpacialPrice"
                autocomplete="off" min="0" step="100">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseCoinReward" class="col-4 col-sm-3 col-md-3 col-form-label">
              Token เมื่อเรียนจบ <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="courseCoinReward" formControlName="courseCoinReward"
                autocomplete="off" min="0" step="10">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseCoinClose" class="col-4 col-sm-3 col-md-3 col-form-label">
              คืน Token เมื่อปิดคอร์ส <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="courseCoinClose" formControlName="courseCoinClose"
                autocomplete="off" min="0" step="10">
            </div>
          </div>
          <!-- // TA // -->
          <div class="form-group row">
            <label for="taId" class="col-4 col-sm-3 col-md-3 col-form-label">
              กำหนด TA <small class="text-danger">(ถ้ามี)</small>
              <br><small class="text-danger">(สำหรับตอบกลับข้อความส่วนตัว)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <!-- <input type="email" class="form-control" id="taId" formControlName="taId" autocomplete="off"> -->
              <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" style="width: 100%;" #value
                [change]="patch(value)">
                <nz-option *ngFor="let option of taList" [nzLabel]="option.EMAIL" [nzValue]="option">
                </nz-option>
              </nz-select>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <label class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              วันเปิด-ปิดคอร์สเรียน <br><small class="text-danger">* กรณีเปิดคอร์สตลอด เลือกแค่วันเริ่มต้น</small>
            </label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <input class="form-control" formControlName="courseDateTime" date-format="dd-MM-yyyy HH:mm:ss"
                [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
                dateFormat="dd-MM-yyyy" autocomplete="off">
              <owl-date-time #dtPicker></owl-date-time>
            </div>
          </div>
          <div class="form-group row">
            <label for="courseSuggest" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              คอร์สแนะนำ <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <mat-form-field style="width: 100%;">
                <mat-select multiple id="courseSuggest" formControlName="courseSuggest"
                  [compareWith]="compareSuggestCourse">
                  <mat-select-trigger>
                    <mat-chip-list>
                      <mat-chip *ngFor="let item of courseForm.value.courseSuggest">
                        {{ item.COURSE_NAME }}
                      </mat-chip>
                    </mat-chip-list>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of courseSuggest" [value]="item">
                    {{ item.COURSE_NAME }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row">
            <label for="type" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">ศูนย์ย่อย</label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag
                [change]="patchLearning(tag, courseForm)" style="width: 100%" [compareWith]="compareLNFn">
                <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
                  [nzValue]="center"></nz-option>
              </nz-select>
            </div>
          </div>
          <div class="form-group row">
            <label for="openDate" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              รายละเอียด<lifedi-require></lifedi-require>
            </label>
            <angular-editor id="_content" class="col-12 col-sm-12 col-md-9 col-lg-10" formControlName="courseDescrition"
              [config]="editorConfig"></angular-editor>
          </div>
        </div>


        <div class="col-12" *ngIf="isAddLesson">
          <div class="form-group row">
            <h5 class="col-4 col-form-label">เพิ่มบทเรียน</h5>
          </div>

          <form [formGroup]="lessonForm">
            <div *ngFor="let c of lessonForm.get('LESSONS')['controls']; let i = index" formArrayName="LESSONS"
              class="mb-3">
              <div [formGroupName]="i" class="container topicBox">
                <button mat-mini-fab class="img close-btn" (click)="removeGroup(i, true)"
                  [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
                <div class="form-group row" style="margin-top: 60px;">
                  <label for="LESSON_NAME" class="col-4 col-sm-3 col-md-3 col-form-label text-right">
                    ชื่อบทเรียน<lifedi-require></lifedi-require>
                  </label>
                  <div class="col-8 col-sm-9 col-md-9">
                    <input type="text" class="form-control" id="LESSON_NAME" formControlName="LESSON_NAME"
                      autocomplete="off" (change)="onChange(c.value, i)">
                  </div>
                </div>
                <div class="form-group row">
                  <label [for]="LESSON_DOC[i]"
                    class="col-4 col-sm-3 col-md-3 col-form-label text-right">เอกสารประกอบการเรียน</label>
                  <div class="col-8 col-sm-9 col-md-9">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input" [id]="LESSON_DOC[i]"
                        accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        (change)="docChange($event, c, i)">
                      <label *ngIf=" !LESSON_DOC[i]" class="custom-file-label" [for]="LESSON_DOC[i]">Choose file</label>
                      <label *ngIf="LESSON_DOC[i]" class="custom-file-label" [for]="LESSON_DOC[i]">
                        {{ LESSON_DOC[i] }}
                      </label>
                    </div>
                  </div>
                </div>
                <div *ngIf="allLesson[i] && allLesson[i].TOPIC !== 'undefined'" class="form-group row">
                  <ul *ngFor="let t of allLesson[i].TOPIC; let j = index" class="list-group list-group-flush"
                    style="width: 100%;">
                    <li class="list-group-item" style="cursor: pointer;"
                      (click)="editCourse(lessonForm.value, i, allLesson[i].LESSON_ID, t.TOPIC_ID, t.TOPIC_TYPE, j)">
                      {{ t.TOPIC_TYPE }} | {{ t.TOPIC_NAME }}
                    </li>
                  </ul>
                </div>

                <div class="row justify-content-center">
                  <lifedi-btn *ngIf="c.valid" lable="เพิ่มหัวข้อ" (click)="addCourse(c.value, i)"
                    customStyle="padding: 0 25px; background: #060E9F; color:#FFFFFF">
                  </lifedi-btn>
                  <lifedi-btn *ngIf="!c.valid" lable="เพิ่มหัวข้อ" disabled="true"
                    customStyle="padding: 0 25px; color:#FFFFFF">
                  </lifedi-btn>
                </div>
              </div>
            </div>
            <button mat-mini-fab class="img" (click)="addGroup(false)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </form>
        </div>
      </div>

      <div class="row justify-content-center">
        <lifedi-btn *ngIf="!isAddLesson && courseForm.valid && courseNumberSuccess" lable="เพิ่มบทเรียน"
          class="mt-3 mb-3" customStyle="padding: 0 25px; background: #060E9F; color:#FFFFFF"
          (click)="addLesson(courseForm.value)">
        </lifedi-btn>
        <lifedi-btn *ngIf="(!isAddLesson && !courseForm.valid || courseNumberError)"
          [ngStyle]="{'display': isAddLesson ? 'none' : 'block' }" lable="เพิ่มบทเรียน" class="mt-3 mb-3"
          customStyle="padding: 0 25px; color:#FFFFFF" disabled="true">
        </lifedi-btn>


        <lifedi-btn *ngIf="isAddLesson && courseForm.valid && lessonForm.valid && courseNumberSuccess"
          lable="Save Draft" class="mt-3 mb-3"
          customStyle="padding: 0 25px; margin-right: 10px; background: #3E8C1A; color:#FFFFFF"
          (click)="saveDraft(courseForm.value, lessonForm.value)">
        </lifedi-btn>
        <lifedi-btn *ngIf="isAddLesson && courseForm.valid && lessonForm.valid && courseNumberSuccess"
          lable="สร้าง Course" class="mt-3 mb-3" customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF"
          (click)="createCourse(courseForm.value, lessonForm.value)">
        </lifedi-btn>
        <lifedi-btn
          *ngIf="(isAddLesson && !courseForm.valid) || (isAddLesson && !lessonForm.valid) || (isAddLesson && !courseNumberSuccess)"
          lable="Save Draft" class="mt-3 mb-3" disabled="true"
          customStyle="padding: 0 25px; margin-right: 10px; color:#FFFFFF">
        </lifedi-btn>
        <lifedi-btn
          *ngIf="(isAddLesson && !courseForm.valid) || (isAddLesson && !lessonForm.valid) || (isAddLesson && !courseNumberSuccess)"
          lable="สร้าง Course" class="mt-3 mb-3" disabled="true" customStyle="padding: 0 25px; color:#FFFFFF">
        </lifedi-btn>
      </div>
    </form>
  </div>



  <div *ngIf="isEdit && courseForm">
    <form [formGroup]="courseForm">

      <div class="row d-flex justify-content-center">
        <div class="col-8">
          <div class="row d-flex justify-content-center">
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openReview" color="primary" class="form-control-plaintext" formControlName="openReview">
                เปิดการใช้งานรีวิว
              </mat-checkbox>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openChat" color="primary" class="form-control-plaintext" formControlName="openChat">
                เปิดการใช้งานห้องสนทนา
              </mat-checkbox>
            </div>
            <div class="col-lg-4 col-md-4 col-sm-4 col-4">
              <mat-checkbox id="openPrivateMessage" color="primary" class="form-control-plaintext"
                formControlName="openPrivateChat">
                เปิดการใช้งานข้อความส่วนตัว
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label for="courseName" class="col-4 col-sm-3 col-md-3 col-form-label">
              รหัสคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="text" class="form-control" id="courseNumber" formControlName="courseNumber"
                autocomplete="off" (focusout)="checkCourseNumber($event)">
              <small *ngIf="courseNumberSuccess" class="text-success">{{ courseNumberSuccess }}</small>
              <small *ngIf="courseNumberError" class="text-danger">{{ courseNumberError }}</small>
            </div>
          </div>
          <div class="form-group row">
            <label for="courseName" class="col-4 col-sm-3 col-md-3 col-form-label">
              ชื่อคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="text" class="form-control" id="courseName" formControlName="courseName" autocomplete="off">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseType" class="col-4 col-sm-3 col-md-3 col-form-label">
              ประเภทคอร์ส<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="display: inline;" formControlName="courseType">
                <option *ngFor="let c of courseType" [id]="c.ID" [value]="c.ID">{{ c.COURSE_TYPE_NAME }}</option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacherId" class="col-4 col-sm-3 col-md-3 col-form-label">
              อาจารย์<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="display: inline;" formControlName="teacherId"
                (change)="selectTeacher($event)">
                <option *ngFor="let t of activeTeacher" [id]="t.TEACHER_ID" [value]="t.TEACHER_ID">
                  {{ t.USERNAME }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group row">
            <label for="teacherAssistant" class="col-4 col-sm-3 col-md-3 col-form-label">
              ผู้สอนร่วม <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <mat-form-field style="width: 100%;">
                <mat-select multiple id="teacherAssistant" formControlName="teacherAssistant"
                  [compareWith]="compareTeacherAssistant">
                  <mat-select-trigger>
                    <mat-chip-list>
                      <mat-chip *ngFor="let item of courseForm.value.teacherAssistant">
                        {{ item.USERNAME }}
                      </mat-chip>
                    </mat-chip-list>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of activeCoTeacherCutSelected" [value]="item">
                    {{ item.USERNAME }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-form-label">
              รูปปก<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <div class="custom-file">
                <input type="file" class="col-8 col-sm-9 col-md-9 custom-file-input" id="coursePic"
                  accept=".png, .jpg, .jpeg" (change)="onCoverSelected($event, courseForm)">
                <label *ngIf="!coursePic" class="custom-file-label" for="coursePic">Choose file</label>
                <label *ngIf="coursePic" class="custom-file-label" for="coursePic">{{ coursePic }}</label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePic" class="col-4 col-sm-3 col-md-3 col-form-label">
              บัญชี<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <select class="custom-select form-control" style="width: 100%;" formControlName="accountId">
                <option *ngFor="let s of account" [value]="s.ACCOUNTING_ID">
                  บัญชี{{ s.ACCOUNTING_NAME }} ({{ s.ACCOUNTING_ID }})
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="form-group row">
            <label class="col-4 col-sm-3 col-md-3 col-form-label">
              วิดีโอตัวอย่าง<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <div class="custom-file">
                <input #exampleVDO type="file" class="custom-file-input" id="exampleVDO"
                  accept="video/mp4, video/x-m4v, video/*" (change)="vdoChange($event, courseForm)">
                <label *ngIf="!exVdo" class="custom-file-label" for="exampleVDO">Choose file</label>
                <label *ngIf="exVdo" class="custom-file-label" for="exampleVDO">{{ exVdo }}</label>
                <small *ngIf="percentage">
                  <span *ngIf="percentage !== 100" class="text-danger">
                    อัปโหลดวิดีโอ {{ percentage | number : '1.0-1' }}%
                  </span>
                  <span *ngIf="percentage === 100" class="text-success">
                    อัปโหลดวิดีโอเรียบร้อย
                  </span>
                </small>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="coursePrice" class="col-4 col-sm-3 col-md-3 col-form-label">
              ราคาปกติ<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="coursePrice" formControlName="coursePrice"
                autocomplete="off" min="0" step="100">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseSpacialPrice" class="col-4 col-sm-3 col-md-3 col-form-label">
              ราคาพิเศษ<lifedi-require></lifedi-require>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="courseSpacialPrice" formControlName="courseSpacialPrice"
                autocomplete="off" min="0" step="100">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseCoinReward" class="col-4 col-sm-3 col-md-3 col-form-label">
              Token เมื่อเรียนจบ <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="number" class="form-control" id="courseCoinReward" formControlName="courseCoinReward"
                autocomplete="off" min="0" step="10">
            </div>
          </div>
          <div class="form-group row">
            <label for="courseCoinClose" class="col-4 col-sm-3 col-md-3 col-form-label">
              คืน Token เมื่อปิดคอร์ส <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <input type="text" class="form-control" id="courseCoinClose" formControlName="courseCoinClose"
                autocomplete="off" min="0" step="10">
            </div>
          </div>
          <!-- // TA // -->
          <div class="form-group row">
            <label for="courseCoinClose" class="col-4 col-sm-3 col-md-3 col-form-label">
              กำหนด TA <small class="text-danger">(ถ้ามี)</small>
              <br><small class="text-danger">(สำหรับตอบกลับข้อความส่วนตัว)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-9">
              <!-- <input type="email" class="form-control" id="courseCoinClose" formControlName="courseCoinClose"
                autocomplete="off"> -->
              <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" style="width: 100%;" #value
                [change]="patch(value)" [(ngModel)]="taSelectList" [ngModelOptions]="{standalone: true}"
                [compareWith]="compareTA">
                <nz-option *ngFor="let option of taList" [nzLabel]="option.EMAIL" [nzValue]="option">
                </nz-option>
              </nz-select>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group row">
            <label class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              วันเปิด-ปิดคอร์สเรียน <br><small class="text-danger">* กรณีเปิดคอร์สตลอด เลือกแค่วันเริ่มต้น</small>
            </label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <input class="form-control" formControlName="courseDateTime" date-format="dd-MM-yyyy HH:mm:ss"
                [selectMode]="'range'" [owlDateTimeTrigger]="dtPicker" [owlDateTime]="dtPicker" [rangeSeparator]="'-'"
                dateFormat="dd-MM-yyyy" autocomplete="off">
              <owl-date-time #dtPicker></owl-date-time>
            </div>
          </div>
          <div class="form-group row">
            <label for="courseSuggest" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              คอร์สแนะนำ <small class="text-danger">(ถ้ามี)</small>
            </label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <mat-form-field style="width: 100%;">
                <mat-select multiple id="courseSuggest" formControlName="courseSuggest"
                  [compareWith]="compareSuggestCourse">
                  <mat-select-trigger>
                    <mat-chip-list>
                      <mat-chip *ngFor="let item of courseForm.value.courseSuggest">
                        {{ item.COURSE_NAME }}
                      </mat-chip>
                    </mat-chip-list>
                  </mat-select-trigger>
                  <mat-option *ngFor="let item of courseSuggest" [value]="item">
                    {{ item.COURSE_NAME }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="form-group row">
            <label for="type" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">ศูนย์ย่อย</label>
            <div class="col-8 col-sm-9 col-md-6 col-lg-5">
              <nz-select nzMode="multiple" [nzTokenSeparators]="[',']" #tag [(ngModel)]="LN_TAG"
                [ngModelOptions]="{standalone: true}" [change]="patchLearning(tag, courseForm)" style="width: 100%"
                [compareWith]="compareLNFn">
                <nz-option *ngFor="let center of allLearningCenter" [nzLabel]="center.CENTER_NAME"
                  [nzValue]="center"></nz-option>
              </nz-select>
            </div>
          </div>
          <div class="form-group row">
            <label for="openDate" class="col-4 col-sm-3 col-md-3 col-lg-2 col-form-label">
              รายละเอียด<lifedi-require></lifedi-require>
            </label>
            <angular-editor id="_content" class="col-12 col-sm-12 col-md-9 col-lg-10" formControlName="courseDescrition"
              [config]="editorConfig"></angular-editor>
          </div>
        </div>



        <div class="col-12" *ngIf="lessonForm.value">
          <div class="form-group row">
            <h5 class="col-4 col-form-label">เพิ่มบทเรียน</h5>
          </div>

          <form [formGroup]="lessonForm">
            <div *ngFor="let c of lessonForm.get('LESSONS')['controls']; let i = index" formArrayName="LESSONS"
              class="mb-3">
              <div [formGroupName]="i" class="container topicBox">
                <button mat-mini-fab class="img close-btn" (click)="removeGroup(i, true)"
                  [style.backgroundImage]="'url(\'../../../../assets/close.png\')'"></button>
                <div class="form-group row" style="margin-top: 60px;">
                  <label class="col-4 col-sm-3 col-md-3 col-form-label text-right">
                    ชื่อบทเรียน<lifedi-require></lifedi-require>
                  </label>
                  <div class="col-8 col-sm-9 col-md-9">
                    <input type="text" class="form-control" formControlName="LESSON_NAME" autocomplete="off"
                      (change)="onChange(c.value, i, $event)" ngDefaultControl>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-4 col-sm-3 col-md-3 col-form-label text-right">เอกสารประกอบการเรียน</label>
                  <div class="col-8 col-sm-8 col-md-8">
                    <div class="custom-file">
                      <input type="file" class="custom-file-input"
                        accept=".pdf, application/pdf, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        (change)="[docChange($event, c, i), onChange(c.value, i, $event)]">
                      <label *ngIf="!LESSON_DOC[i]" class="custom-file-label">
                        Choose file
                      </label>
                      <label *ngIf="LESSON_DOC[i]" class="custom-file-label">
                        {{ LESSON_DOC[i] }}
                      </label>
                    </div>
                  </div>
                  <div *ngIf="allLesson[i]?.LESSON_DOC" class="col-1 col-form-label">
                    <a [href]="allLesson[i].LESSON_DOC" target="_blank" style="cursor: pointer;">
                      <img src="../../../../assets/document.png" style="width: 20px;">
                    </a>
                  </div>
                </div>
                <div *ngIf="allLesson[i] && allLesson[i].TOPIC !== 'undefined'" class="form-group row">
                  <ul *ngFor="let t of allLesson[i].TOPIC; let j = index" class="list-group list-group-flush"
                    style="width: 100%;">
                    <li class="list-group-item" style="cursor: pointer;"
                      (click)="editCourse(lessonForm.value, i, allLesson[i].LESSON_ID, t.TOPIC_ID, t.TOPIC_TYPE, j)">
                      {{ t.TOPIC_TYPE }} | {{ t.TOPIC_NAME }}
                    </li>
                  </ul>
                </div>

                <div class="row justify-content-center">
                  <lifedi-btn *ngIf="c.valid" lable="เพิ่มหัวข้อ" (click)="addCourse(c.value, i)"
                    customStyle="padding: 0 25px; background: #060E9F; color:#FFFFFF">
                  </lifedi-btn>
                  <lifedi-btn *ngIf="!c.valid" lable="เพิ่มหัวข้อ" disabled="true"
                    customStyle="padding: 0 25px; color:#FFFFFF">
                  </lifedi-btn>
                </div>
              </div>
            </div>
            <button mat-mini-fab class="img" (click)="addGroup(true)"
              [style.backgroundImage]="'url(https://lifedi2021-production.s3.ap-southeast-1.amazonaws.com/measure/add.png)'">
            </button>
          </form>
        </div>

      </div>
      <div class="row justify-content-center pt-2 pb-3">
        <div *ngIf="courseDetail.COURSE_STATUS === 0 || courseDetail.COURSE_STATUS === 1">
          <lifedi-btn *ngIf="courseForm.valid && lessonForm.valid && !courseNumberError" lable="บันทึก"
            class="mt-3 mb-3" (click)="createCourse(courseForm.value, lessonForm.value)"
            customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF">
          </lifedi-btn>
          <lifedi-btn *ngIf="!courseForm.valid || !lessonForm.valid || courseNumberError" lable="บันทึก"
            class="mt-3 mb-3" disabled="true" customStyle="padding: 0 25px; color:#FFFFFF">
          </lifedi-btn>
        </div>

        <div *ngIf="courseDetail.COURSE_STATUS === 999 || courseDetail.COURSE_STATUS === 99">
          <lifedi-btn *ngIf="courseForm.valid && lessonForm.valid && !courseNumberError" lable="Save Draft"
            class="mt-3 mb-3" customStyle="padding: 0 25px; margin-right: 10px; background: #3E8C1A; color:#FFFFFF"
            (click)="saveDraft(courseForm.value, lessonForm.value)">
          </lifedi-btn>
          <lifedi-btn *ngIf="!courseForm.valid || !lessonForm.valid || courseNumberError" lable="Save Draft"
            class="mt-3 mb-3" disabled="true" customStyle="padding: 0 25px; margin-right: 10px; color:#FFFFFF">
          </lifedi-btn>

          <lifedi-btn *ngIf="courseForm.valid && lessonForm.valid && !courseNumberError" lable="สร้างคอร์ส"
            class="mt-3 mb-3" (click)="createCourse(courseForm.value, lessonForm.value)"
            customStyle="padding: 0 25px; background: #005C3D; color:#FFFFFF">
          </lifedi-btn>
          <lifedi-btn *ngIf="!courseForm.valid || !lessonForm.valid || courseNumberError" lable="สร้างคอร์ส"
            class="mt-3 mb-3" disabled="true" customStyle="padding: 0 25px; color:#FFFFFF">
          </lifedi-btn>
        </div>
      </div>
    </form>
  </div>
</div>